module.exports = __webpack_public_path__ + "img/vocabulary.a2e83378.svg";